// extracted by mini-css-extract-plugin
export default {"Form":"eTQMNlPY7i8lp62CylyX","ButtonsContainer":"yku8bvop_i4fnvXOWeH5"};